import type { TypeDatasetData } from './types';
import setDataset from './setDataset';

// ----------------------------------------------------------------------------

function setDatasetData(element: HTMLElement, data: TypeDatasetData): void {
    for (const key of Object.keys(data)) {
        const value = data[key];

        setDataset(element, key, value);
    }
}

// ----------------------------------------------------------------------------

export default setDatasetData;
